var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-menu',{attrs:{"mode":"inline","inlineIndent":40,"default-selected-keys":[_vm.defaultSelected]}},[_vm._l((_vm.menuItems),function(item){return [_c('a-menu-item',{key:item.key,staticStyle:{"text-align":"left"},on:{"click":function($event){return _vm.handleSelectMenu(item.key)}}},[_vm._v(" "+_vm._s(item.title)+" ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }